var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "z01_\u9996\u9875") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.46,26.7,34.77,6.19a4.29,4.29,0,0,0-5.66,0L5.41,26.7a3.75,3.75,0,0,0-1.06,4.59A4.27,4.27,0,0,0,8.6,34.12h2.12V54.28a4.69,4.69,0,0,0,4.6,4.6H49.26a4.69,4.69,0,0,0,4.55-4.09s0-.11,0-.16V54.5c0-.07,0-.15,0-.22V51.1a1.36,1.36,0,0,0,0-.2V34l1.79.14a4.58,4.58,0,0,0,4.24-2.83A4.4,4.4,0,0,0,58.46,26.7ZM37.24,54.63H26.63V40.84H37.24ZM51,30.23c-1.06,0-1,.8-1,2.12V54.28h-8.2V40.49a4.09,4.09,0,0,0-4.25-4.25H27a4.09,4.09,0,0,0-4.25,4.25V54.28H15.32V32.35a2.28,2.28,0,0,0-2.13-2.12H8.6L31.94,9.72,55.63,30.23Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.b1a659aa.svg";
export { ForwardRef as ReactComponent };